var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('router-view'),_c('app-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }